import { useCheckIsUpdatePeriod } from '../../../../components/update-period-announcement-panel';
import { useUser } from '../../../../user-management';
import {
  AddClassroomDropdown,
  ClassroomDropdownOptions,
} from '../../../components/add-classroom-dropdown';
import { useManageClassrooms } from '../../../hooks/use-manage-classrooms';
import { useSchoolCapabilities } from '../../../hooks/use-school-capabilities';

function SchoolClassroomsDropdown(): JSX.Element {
  const {
    classrooms: { canCreateClassrooms },
  } = useSchoolCapabilities();
  const { user } = useUser();
  const isUpdatePeriod = useCheckIsUpdatePeriod();
  const { handleOnError } = useManageClassrooms();

  return (
    <>
      {canCreateClassrooms && (
        <AddClassroomDropdown
          size="M"
          disabled={!user || isUpdatePeriod}
          options={[
            ClassroomDropdownOptions.ADD,
            ClassroomDropdownOptions.IMPORT,
          ]}
          onError={handleOnError}
        />
      )}
    </>
  );
}

export { SchoolClassroomsDropdown };
